function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { useContext } from "react";
import { CarinaContext } from "../../CarinaProvider";
var buildStyle = function(param) {
    var animation = param.animation;
    var _easeInOut = animation.productive.easeInOut, easing = _easeInOut.easing, _duration = _easeInOut.duration, duration = _duration.medium;
    return {
        wrapper: {
            base: {
                width: '100%',
                overflow: 'hidden',
                boxSizing: 'border-box'
            },
            showOverhang: {
                padding: '0 50px'
            }
        },
        slider: {
            base: {
                display: 'flex',
                alignItems: 'stretch',
                margin: 0,
                padding: 0,
                listStyle: 'none',
                width: '100%',
                boxSizing: 'border-box',
                transitionProperty: 'transform',
                transitionDuration: duration,
                transitionTimingFunction: easing
            },
            reducedMotion: {
                transitionProperty: 'none'
            },
            isTouching: {
                transitionDuration: '0s'
            }
        }
    };
};
var useStyle = function(param) {
    var cols = param.cols, deltaX = param.deltaX, hasNext = param.hasNext, hasPrevious = param.hasPrevious, isRtl = param.isRtl, isTouching = param.isTouching, showOverhang = param.showOverhang, slideHeight = param.slideHeight, slideIndex = param.slideIndex;
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            wrapper: {},
            slider: {}
        };
    }
    var wrapper = builtStyle.wrapper, slider = builtStyle.slider;
    var rtlMultiplier = isRtl ? 1 : -1;
    var translation = "".concat(rtlMultiplier * slideIndex * 100 / (cols || 1), "%");
    var pxAdjust = isTouching ? deltaX : 0;
    if (showOverhang) {
        if (!hasPrevious && hasNext) {
            translation = "".concat(rtlMultiplier * 50, "px");
        } else if (!hasNext && hasPrevious) {
            pxAdjust += rtlMultiplier * -50;
        }
    }
    return {
        wrapper: _objectSpread({}, wrapper.base, showOverhang && wrapper.showOverhang),
        slider: _objectSpread({}, slider.base, isTouching && slider.isTouching, {
            transform: "translateX(".concat(translation, ") translateX(").concat(pxAdjust, "px)")
        }, prefersReducedMotion && slider.reducedMotion, {
            height: slideHeight || 'auto'
        })
    };
};
export default useStyle;
